import store from '../../../store';
import {inputValid, inputInvalid} from '../../../actions/validation';

export function runStepValidations(stepHandle) {
  const {
    entities: {steps},
  } = store.getState();
  const step = steps[stepHandle];

  const validQuestions = step.questions
    .map(runQuestionValidations)
    .filter(isValid => isValid);

  return validQuestions.length === step.questions.length;
}

export function runQuestionValidations(questionHandle) {
  const {
    entities: {questions},
  } = store.getState();
  const question = questions[questionHandle];
  const {validations = {}} = question;
  const {requireOneOf} = validations;

  if (requireOneOf) {
    return validateOneOf(question);
  } else {
    return validateAll(question);
  }
}

export function clearQuestionValidations(questionHandle) {
  const {
    entities: {questions},
  } = store.getState();
  const question = questions[questionHandle];

  question.inputs.forEach(inputHandle =>
    store.dispatch(inputValid(inputHandle))
  );
}

function validateOneOf(question) {
  const {
    entities: {inputs},
  } = store.getState();
  const {
    validations: {requireOneOf},
  } = question;

  const validations = requireOneOf
    .map(inputHandle => inputs[inputHandle])
    .filter(input => !input.hidden)
    .reduce(addOtherInputs, [])
    .map(validateInput);

  const isValid = Boolean(
    validations.filter(validation => validation.isValid).length
  );

  validations.forEach(validation => dispatchValidation(isValid, validation));

  return isValid;
}

function validateAll(question) {
  const {
    entities: {inputs},
  } = store.getState();

  const validations = question.inputs
    .map(inputHandle => inputs[inputHandle])
    .filter(input => !input.hidden)
    .reduce(addOtherInputs, [])
    .map(validateInput)
    .map(validation => dispatchValidation(validation.isValid, validation));

  return validations.filter(validation => !validation.isValid).length === 0;
}

function dispatchValidation(isValid, validation) {
  const {input} = validation;

  if (isValid) {
    store.dispatch(inputValid(input.handle));
  } else {
    store.dispatch(inputInvalid(input.handle, validation));
  }

  return validation;
}

/**
 * This function is used in a reducer to conditionally add
 * in the input as well as the `otherId` input it's options
 * references if that value is currently selected.
 *
 * This way we only validation the `hidden` referenced inputs
 * when they are actually made visible.
 *
 * @param validatedInputs
 * @param input
 */
function addOtherInputs(validatedInputs, input) {
  const {
    entities: {inputs},
  } = store.getState();
  const {value} = input;
  const otherInputs = [input];

  if (value && Array.isArray(input.options)) {
    input.options.forEach(option => {
      const {otherId} = option;
      const valueCheck = Array.isArray(value)
        ? value.includes(option.value)
        : value === option.value;

      if (otherId && valueCheck) {
        otherInputs.push(inputs[otherId]);
      }
    });
  }

  return [...validatedInputs, ...otherInputs];
}

/**
 * Validates the specified input by returning an object
 * indicating if the input is valid.
 *
 * Since an input can be invalid for many reasons the message
 * will only indicate the first validation issue encountered.
 *
 * @param input
 * @returns {*}
 */
function validateInput(input) {
  const {validations = {}} = input;

  if (validations.optional === true) {
    return {
      input,
      isValid: true,
    };
  }

  return validateRequired(input);
}

function validateRequired(input) {
  const value = input.value || '';
  const strValue = value.toString().trim();

  if (strValue) {
    return {
      input,
      isValid: true,
    };
  } else {
    return {
      input,
      isValid: false,
      message: 'This field is required',
    };
  }
}
